(() => {
  if (window.__admiralCartUpsellsInitialized) return;

  window.__admiralCartUpsellsInitialized = true;

  const savedChatStyles = new Map();

  let chatTimer = null;
  let lastDrawerState = null;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  async function waitForDrawer() {
    if (!customElements.get('cart-drawer')) {
      await customElements.whenDefined('cart-drawer');
    }

    return getDrawer();
  }

  async function addVariant(button, variantId) {
    if (!variantId) return;
    if (button.dataset.loading === 'true') return;

    button.dataset.loading = 'true';
    button.classList.add('is-loading');
    button.disabled = true;

    try {
      const drawer = await waitForDrawer();

      if (!drawer) {
        throw new Error('Cart drawer was not found.');
      }

      if (
        typeof drawer.getSectionsToRender !== 'function' ||
        typeof drawer.renderContents !== 'function'
      ) {
        throw new Error(
          'Native Sense cart drawer methods are unavailable.'
        );
      }

      const formData = new FormData();

      formData.append('id', String(variantId));
      formData.append('quantity', '1');

      const sectionIds = drawer
        .getSectionsToRender()
        .map((section) => section.id);

      formData.append(
        'sections',
        sectionIds.join(',')
      );

      formData.append(
        'sections_url',
        window.location.pathname
      );

      if (typeof drawer.setActiveElement === 'function') {
        drawer.setActiveElement(button);
      }

      const response = await fetch(
        window.routes?.cart_add_url || '/cart/add.js',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        }
      );

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          result.message ||
          'Не вдалося додати товар.'
        );
      }

      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
    } catch (error) {
      console.error(
        '[Admiral cart] Add error:',
        error
      );

      button.classList.add('has-error');

      window.setTimeout(() => {
        if (button.isConnected) {
          button.classList.remove('has-error');
        }
      }, 1200);
    } finally {
      if (button.isConnected) {
        button.dataset.loading = 'false';
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      '[data-av-cart-add]'
    );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    addVariant(
      button,
      button.dataset.variantId
    );
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest(
      '[data-av-variant-select]'
    );

    if (!select) return;

    const container = select.closest(
      '.av-cart-cartridge'
    );

    const button = container?.querySelector(
      '[data-av-cart-add]'
    );

    if (button) {
      button.dataset.variantId = select.value;
    }
  });

  function getOpenRoots(
    root = document,
    roots = []
  ) {
    roots.push(root);

    root.querySelectorAll?.('*').forEach(
      (element) => {
        if (element.shadowRoot) {
          getOpenRoots(
            element.shadowRoot,
            roots
          );
        }
      }
    );

    return roots;
  }

  function isFloatingChat(element) {
    if (!(element instanceof Element)) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);

    if (style.position !== 'fixed') {
      return false;
    }

    if (
      rect.width < 28 ||
      rect.height < 28 ||
      rect.width > 240 ||
      rect.height > 240
    ) {
      return false;
    }

    return (
      rect.right >= window.innerWidth - 50 &&
      rect.bottom >= window.innerHeight - 50
    );
  }

  function findChatElements() {
    const found = new Set();

    const selectors = [
      '#shopify-chat',
      '#ShopifyChat',
      'shopify-chat',
      '[data-shopify-chat]',
      '[data-shopify-inbox]',
      '[id*="shopify-chat" i]',
      '[class*="shopify-chat" i]',
      '[aria-label*="chat" i]',
      '[aria-label*="message" i]',
      '[aria-label*="повідом" i]',
      '[aria-label*="сообщ" i]',
      '[title*="chat" i]',
      '[data-testid*="chat" i]',
      'iframe[src*="shopifyinbox" i]',
      'iframe[src*="shopify-inbox" i]',
      'iframe[title*="chat" i]'
    ];

    getOpenRoots().forEach((root) => {
      selectors.forEach((selector) => {
        try {
          root
            .querySelectorAll(selector)
            .forEach((element) => {
              let target = element;
              let parent = element.parentElement;

              while (
                parent &&
                parent !== document.body
              ) {
                if (isFloatingChat(parent)) {
                  target = parent;
                  break;
                }

                parent = parent.parentElement;
              }

              found.add(target);
            });
        } catch (_) {}
      });
    });

    return found;
  }

  function hideChat() {
    findChatElements().forEach((element) => {
      if (!savedChatStyles.has(element)) {
        savedChatStyles.set(
          element,
          element.getAttribute('style')
        );
      }

      element.style.setProperty(
        'display',
        'none',
        'important'
      );

      element.style.setProperty(
        'visibility',
        'hidden',
        'important'
      );

      element.style.setProperty(
        'opacity',
        '0',
        'important'
      );

      element.style.setProperty(
        'pointer-events',
        'none',
        'important'
      );
    });
  }

  function restoreChat() {
    savedChatStyles.forEach(
      (style, element) => {
        if (!element.isConnected) return;

        if (style === null) {
          element.removeAttribute('style');
        } else {
          element.setAttribute(
            'style',
            style
          );
        }
      }
    );

    savedChatStyles.clear();
  }

  function syncDrawerState() {
    const drawer = getDrawer();

    const isOpen = Boolean(
      drawer?.classList.contains('active')
    );

    document.documentElement.classList.toggle(
      'av-cart-open',
      isOpen
    );

    document.body?.classList.toggle(
      'av-cart-open',
      isOpen
    );

    if (lastDrawerState === isOpen) {
      if (isOpen) hideChat();
      return;
    }

    lastDrawerState = isOpen;

    if (chatTimer) {
      clearInterval(chatTimer);
      chatTimer = null;
    }

    if (isOpen) {
      hideChat();

      chatTimer = window.setInterval(
        hideChat,
        400
      );
    } else {
      restoreChat();
    }
  }

  const observer = new MutationObserver(
    syncDrawerState
  );

  function init() {
    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      }
    );

    syncDrawerState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();